import React from 'react';
import { AlertTriangle, RefreshCcw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error || 'Unknown error');
    return (
      <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#050505', color: '#fff' }}>
        <div className="max-w-md w-full p-8 rounded-2xl border border-[#FF5F00]/30 bg-black/80" data-testid="error-boundary">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ background: 'rgba(255,95,0,0.1)', border: '1px solid rgba(255,95,0,0.4)' }}>
            <AlertTriangle className="w-6 h-6" style={{ color: '#FF5F00' }} />
          </div>
          <h1 className="text-2xl font-black tracking-tight mb-2" style={{ fontFamily: 'Cabinet Grotesk, Manrope, sans-serif' }}>Quelque chose a planté.</h1>
          <p className="text-sm text-zinc-400 mb-4">L&apos;application a rencontré une erreur. Recharge la page pour repartir sur de bonnes bases. Si le problème persiste, déconnecte-toi puis reconnecte-toi.</p>
          <pre className="text-xs text-zinc-500 font-mono p-3 rounded bg-white/[0.03] border border-white/5 mb-5 overflow-auto max-h-32">{msg.slice(0, 400)}</pre>
          <button onClick={this.reset} className="w-full inline-flex items-center justify-center gap-2 h-11 rounded-md font-semibold" style={{ background: '#D4FF00', color: '#000' }} data-testid="error-boundary-reload">
            <RefreshCcw className="w-4 h-4" /> Recharger
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
